export default __webpack_public_path__ + "static/media/wire.e15daea2.svg";